var React = require('react');

function ChevronLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.83 21.17L12 24 0 12 12 0l2.83 2.83L5.66 12z"}));
}

ChevronLeftInline.defaultProps = {"height":"10","viewBox":"0 0 15 24","role":"img","aria-label":""};

module.exports = ChevronLeftInline;

ChevronLeftInline.default = ChevronLeftInline;
